import { IIntegrationUploadHistoryResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { toDataSourceResult } from 'utils/query_v3';

export type IntegrationUploadFilter = Readonly<{
    locationId: string;
    integrationId: string;
}>;

export type IntegrationUploadHistoryDataSourceOptions = BaseDataSourceOptions<
    IIntegrationUploadHistoryResponse,
    IntegrationUploadFilter
>;
export type IntegrationUploadHistoryPagedDataSource = PagedDataSource<
    IIntegrationUploadHistoryResponse,
    IntegrationUploadFilter
>;
export type IntegrationUploadHistoryInfiniteDataSource = InfiniteDataSource<
    IIntegrationUploadHistoryResponse,
    IntegrationUploadFilter
>;

const getIntegrationUploadHistory: DataSourceQuery<
    IIntegrationUploadHistoryResponse,
    IntegrationUploadFilter
> = ({ filter: { locationId, integrationId }, page, pageLimit }) =>
    toDataSourceResult(
        sdClient.getIntegrationUploadHistory({
            id: locationId,
            integrationId,
            page,
            pageLimit,
        })
    );

export function usePagedIntegrationUploadHistoryDataSource(
    options: IntegrationUploadHistoryDataSourceOptions
): IntegrationUploadHistoryPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: getIntegrationUploadHistory,
    });
}

export function useInfiniteIntegrationUploadHistoryDataSource(
    options: IntegrationUploadHistoryDataSourceOptions
): IntegrationUploadHistoryInfiniteDataSource {
    return useInfiniteDataSource({
        ...options,
        query: getIntegrationUploadHistory,
    });
}
